import React from "react";
import { useHistory } from "react-router-dom";
import { useAuth } from "modules/hooks/auth";
import { SelectPrimitive } from "components/Inputs/Select";
import { OptionType } from "components/Inputs/Select";
import * as Form from "components/Form";
import styles from "./styles.module.scss";

const OrganizationSelector: React.FunctionComponent = () => {
  const { organizations, selectedOrganizationId, setSelectedOrganizationId } =
    useAuth();
  const history = useHistory();

  // Don't show selector if user has only one or no organizations
  if (!organizations || organizations.length <= 1) {
    return null;
  }

  const options: OptionType[] = organizations.map((org) => ({
    value: org.organizationId,
    label: org.organizationName,
  }));

  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedId = event.target.value;
    setSelectedOrganizationId(selectedId);
    // Navigate to dashboard to refresh data with new organization context
    history.push("/");
  };

  return (
    <div className={styles.organizationSelector}>
      <Form.Control label="ACP List" fieldId="organization-selector">
        <SelectPrimitive
          name="organization-selector"
          options={options}
          value={
            selectedOrganizationId || organizations[0]?.organizationId || ""
          }
          onChange={handleChange}
          placeholder="Select organization"
        />
      </Form.Control>
    </div>
  );
};

export default OrganizationSelector;
